import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  Text,
  Box,
  Image,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Button,
  Flex,
  Spacer,
  VStack,
  HStack,
  Icon,
  Tab,
  Switch,
  IconButton,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalContent,
  Center,
} from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AccountContext } from '../AccountContext';
import Loading from '../LoadingWithHeader';
import NoUserHeader from '../AreaLivre/NoUserHeader';
import ChildHeader from '../Dashboard/Main/ChildHeader';
import AvisoPendencias from '../../images/AvisoPendencias.svg';
import FamiliaIcon from '../../images/dashboard/familia.svg';
import DrawerIndicacao from './DrawerIndicacao';
import { loadPlans } from 'api/plans';
import { api } from 'api/api';
import useModelPagamentoTelemed from '../Dashboard/Telemedicina/useModelPagamentoTelemed';
import { FaCheck, FaStar, FaUser } from 'react-icons/fa6';
import { MdFamilyRestroom } from 'react-icons/md';
import { CloseIcon } from '@chakra-ui/icons';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function Plano({ telemedicina, onLoaded, header }) {
  const normalizarArray = (valor) => {
    if (!valor) return [];

    const str = String(valor).trim();

    if (str === '{NULL}' || str === 'NULL' || str === 'null' || str === '{}') {
      return [];
    }

    if (Array.isArray(valor)) {
      return valor.map(Number).filter((n) => !isNaN(n));
    }

    if (str.startsWith('{')) {
      return str
        .replace(/[{}]/g, '')
        .split(',')
        .map((v) => v.trim())
        .filter((v) => v && v.toLowerCase() !== 'null')
        .map(Number)
        .filter((n) => !isNaN(n));
    }

    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) {
        return parsed.map(Number).filter((n) => !isNaN(n));
      }
    } catch (e) {}

    const num = Number(str);
    return isNaN(num) ? [] : [num];
  };

  const [plans, setPlans] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [maxParcelas, setMaxParcelas] = useState(null);
  const { state } = useLocation();
  telemedicina = state?.telemedicina;
  const { user, setPage, setUser } = useContext(AccountContext);
  const [error, setError] = useState(false);
  const [assinaturaLiberada, setAssinaturaLiberada] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingAssinatura, setLoadingAssinatura] = useState(true);
  const [menorValor, setMenorValor] = useState(null);
  const [modalAnualOpen, setModalAnualOpen] = useState(false);
  const [planoSelecionado, setPlanoSelecionado] = useState(null);
  let clientId = state?.client_id ? state?.client_id : user.id_cliente_deovita;

  const navigate = useNavigate();
  // Hook deve ser chamado no topo
  const { fetchVincularVoucher } = useModelPagamentoTelemed();

  let planoRestrito = null;
  let formaRestrita = null;
  let descontoPlano = null;
  let valorFinalPlano = null;
  let valorBasePlano = null;
  let parcelasRestritas = null;
  let descricaoVoucher = null;
  let planosExibir = plans;
  let voucherInfo = null;

  let sinistralidade = null;

  if (user?.voucher?.voucher?.sinistralidade) {
    sinistralidade = Number(user.voucher.voucher.sinistralidade) || 0;
  }

  const isVoucherAnual = sinistralidade === 1;
  const isVoucherMensal = sinistralidade === 12;
  if (user && user.voucher && user.voucher.voucher && user.voucher.voucher.voucher_type === 'Assinatura') {
    console.log(user.voucher.voucher);
    planoRestrito = normalizarArray(user.voucher.voucher.plano_ids || user.voucher.voucher.plano_id);
    formaRestrita = normalizarArray(user.voucher.voucher.forma_ids || user.voucher.voucher.forma_id);

    console.log('Informações do voucher:', {
      planoRestrito,
      formaRestrita,
    });

    descontoPlano = user.voucher.voucher.percent;
    valorFinalPlano = user.voucher.voucher.valor_final;
    parcelasRestritas = user.voucher.voucher.parts;

    if (!planoRestrito.length || planoRestrito.includes(0)) {
      planosExibir = plans;
    } else {
      planosExibir = plans.filter((p) => planoRestrito.includes(Number(p.id)));
    }

    planosExibir = planosExibir.map((p) => {
      let parcelasFiltradas;

      if (!formaRestrita.length || formaRestrita.includes(0)) {
        parcelasFiltradas = p?.parcelas;
      } else {
        parcelasFiltradas = p?.parcelas?.filter((parc) => formaRestrita.includes(Number(parc.forma_id)));

        if (!parcelasFiltradas || parcelasFiltradas.length === 0) {
          parcelasFiltradas = p?.parcelas;
        }
      }

      return {
        ...p,
        parcelas: parcelasFiltradas,
        parcelasFiltradasVoucher: parcelasFiltradas,
      };
    });

    voucherInfo = {
      desconto: descontoPlano,
      valorFinal: valorFinalPlano,
      formaPagamento: user.voucher.voucher.forma_pagamento,
      planoId: planoRestrito,
      planoNome: user.voucher.voucher.plano,
    };
  }

  useEffect(() => {
    setPage('Planos DeoVita');
  }, [setPage]);

  useEffect(() => {
    (async () => {
      try {
        const data = await loadPlans();

        const valores = data
          .flatMap((plano) => plano?.parcelas || [])
          .map((parcela) => Number(parcela.min_valor))
          .filter((valor) => !isNaN(valor));

        const menor = valores.length > 0 ? Math.min(...valores) : null;

        const allParcelas = data.flatMap((plano) => plano?.parcelas || []);
        const maxParcelasValue = allParcelas.length > 0 ? Math.max(...allParcelas.map((p) => p.quantidade)) : null;
        setMaxParcelas(maxParcelasValue);

        setMenorValor(menor);
        setPlans(data);
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {}, [user, assinaturaLiberada, loading]);

  const getCancelamento = useCallback(() => {
    setLoadingAssinatura(true);
    api(`${ENDPOINT}/clients/getContratoCancelado`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cpf: user?.cpf }),
    })
      .catch((err) => {
        return;
      })
      .then(async (res) => {
        if (!res || !res.ok || res.status >= 400) {
          return;
        }
        return await res.json();
      })
      .then(async (resposta) => {
        setLoadingAssinatura(false);
        if (resposta?.data !== undefined && resposta?.data.length) {
          const dataAtual = new Date();
          const dataCadastro = new Date(resposta.data[0].data_cadastro);

          const dataCadastroSimples = new Date(dataCadastro.getFullYear(), dataCadastro.getMonth(), dataCadastro.getDate());

          const dataCadastroMais90Dias = new Date(dataCadastroSimples);
          dataCadastroMais90Dias.setDate(dataCadastroMais90Dias.getDate() + 90);

          const dataAtualSimples = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate());

          const resultado = dataAtualSimples >= dataCadastroMais90Dias;

          if (!resultado) {
            //O cancelamento do cliente não completou noventa dias
            if (state?.tipo !== 'recontratar_plano') {
              setAssinaturaLiberada(false);
              return;
            }
          }
          setAssinaturaLiberada(true);
        } else {
          setAssinaturaLiberada(true);
        }
      });
  }, [state?.tipo, user?.cpf]);

  useEffect(() => {
    getCancelamento();
  }, [getCancelamento]);

  useEffect(() => {
    return () => {
      if (user && user.voucher && user.voucher.voucher && user.voucher.voucher.voucher_type === 'Assinatura' && !assinaturaLiberada) {
        setUser((prevUser) => ({
          ...prevUser,
          voucher: null,
        }));
      }
    };
  }, [user, assinaturaLiberada, setUser]);

  useEffect(() => {
    if (menorValor != null) {
      onLoaded?.(menorValor);
    }
  }, [menorValor, onLoaded]);

  if (loadingAssinatura || loading) {
    return <Loading />;
  }

  async function handleSubmit(planoArg, options = { anual: false }) {
    const plano = planoArg;
    const isPlanoAnual = options.anual;

    let quantidadeDesejada;

    if (isVoucherAnual) {
      quantidadeDesejada = 1;
    } else if (isVoucherMensal) {
      quantidadeDesejada = 12;
    } else {
      quantidadeDesejada = isPlanoAnual ? 1 : 12;
    }

    const parcela = plano?.parcelas?.find((p) => Number(p.quantidade) === Number(quantidadeDesejada));

    if (!parcela) return;

    const planosVoucher = normalizarArray(user?.voucher?.voucher?.plano_id);

    const isVoucherAssinatura =
      user?.voucher?.voucher?.voucher_type === 'Assinatura' &&
      (!planosVoucher.length || planosVoucher.includes(0) || planosVoucher.includes(Number(plano.id)));
    const valorOriginal = Number(parcela.min_valor);

    let valorComDesconto = valorOriginal;

    if (isVoucherAssinatura) {
      const desconto = Number(user.voucher.voucher.percent);
      valorComDesconto = valorOriginal * (1 - desconto / 100);
    }

    const valorEconomizado = valorOriginal - valorComDesconto;

    if (isVoucherAssinatura) {
      await fetchVincularVoucher(user.voucher.voucher.voucher, valorComDesconto, valorOriginal);
    }

    let params = {
      ...state,
      client_id: user.id_cliente_deovita,
      name: user.name,
      cpf: user.cpf,

      id_plano: plano.id,
      nome_plano: plano.nome,
      dependentes_plano: plano.qtd_dependentes,

      parcelsActive: isPlanoAnual,
      plano_anual: isPlanoAnual,
      frequencia: parcela.quantidade,

      valor: valorComDesconto,
      valor_plano: valorComDesconto,
      valor_plano_formatado: valorComDesconto.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      }),

      valor_original: valorOriginal,
      valorEconomizado: valorEconomizado,

      frequenciaText: `Assinatura Plano ${plano.nome}`,

      navig_to: '/alerts/sucesso/telemedicina2/',
      expiration_pix_in_min: 5,

      item: {
        client_id: user.id_cliente_deovita,
        nome: user.name,
        fone: user?.phone1 ? user.phone1 : user?.phone2,
        adicionais: null,
        plano: plano.id,
        phone: user?.phone1 ? user.phone1 : user?.phone2,
      },

      service: 'contract',
      voucher: user.voucher ? user.voucher : null,

      descricao_plano: plano.nome,
      plano: plano,
      parcela: parcela,

      phone: user?.phone1 ? user.phone1 : user?.phone2,
    };

    let carrinho = [
      {
        id: 0,
        nome: params.nome_plano,
        valor: params.valor_plano_formatado,
        valor_numerico: params.valor_plano,
      },
    ];

    if (!user.loggedIn) {
      navigate('/cadastro', {
        state: { assinatura: { dados: params, carrinho: carrinho } },
      });
      return;
    }

    if (user.termo) {
      navigate('/pagamentos', {
        state: { ...params, carrinho: carrinho },
      });
      return;
    }

    navigate('/termo-de-adesao', {
      state: { dados: params, carrinho: carrinho },
    });
  }

  function PlanoCard({ planId, titulo, beneficios, color, recomendado, onAssinar, tipo = 'mensal', plan }) {
    const planosVoucher = normalizarArray(user?.voucher?.voucher?.plano_id);

    const isVoucher =
      user?.voucher?.voucher?.voucher_type === 'Assinatura' &&
      (!planosVoucher.length || planosVoucher.includes(0) || planosVoucher.includes(Number(plan.id)));
    const isFamilia = planId === 29;
    const mainColor = planId === 29 ? '#EB8B2A' : color || '#2A918A';

    const parcelasBase = isVoucher && plan?.parcelasFiltradasVoucher?.length > 0 ? plan.parcelasFiltradasVoucher : plan?.parcelas || [];

    const parcelaMensal = parcelasBase.find((p) => Number(p.quantidade) === 12);
    const parcelaAnual = parcelasBase.find((p) => Number(p.quantidade) === 1);

    let preco = '';

    const aplicarDesconto = (valor) => {
      if (isVoucher) {
        const desconto = Number(user.voucher.voucher.percent);
        return valor * (1 - desconto / 100);
      }
      return valor;
    };

    let tipoFinal = tipo;

    if (isVoucherAnual) tipoFinal = 'anual';
    if (isVoucherMensal) tipoFinal = 'mensal';

    if (tipoFinal === 'mensal') {
      if (parcelaMensal) {
        let valor = Number(parcelaMensal.min_valor);
        valor = aplicarDesconto(valor);

        preco = valor.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
      }
    } else if (tipoFinal === 'anual') {
      if (parcelaAnual) {
        let valor = Number(parcelaAnual.min_valor);
        valor = aplicarDesconto(valor);

        preco = `12x ${(valor / 12).toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}`;
      }
    }

    let economiaPercent = null;

    if (parcelaMensal && parcelaAnual) {
      const valorMensalTotal = parcelaMensal.min_valor * 12;
      const valorAnual = parcelaAnual.min_valor;

      economiaPercent = Math.round(((valorMensalTotal - valorAnual) / valorMensalTotal) * 100);
    }

    return (
      <Box border={`2px solid ${isFamilia ? '#EB8B2A' : '#B6D5D4'}`} borderRadius="20px" bg={isFamilia ? '#FFF5EC' : '#F7FDFC'} p={5} boxShadow="sm">
        <VStack align="start" spacing={4}>
          {recomendado && (
            <Box w="100%" display="flex" justifyContent="center">
              <HStack borderRadius={'1em'} p={2} bg={mainColor} color={'white'} justifyContent="center" w="50%">
                <Text fontSize="sm">⭐ Recomendado!</Text>
              </HStack>
            </Box>
          )}

          <Text fontWeight="bold" fontSize="1.2em" color={mainColor}>
            {tipoFinal === 'anual' ? 'Assinatura Plano' : 'Mensalidade Plano'} {titulo}
          </Text>

          <Text fontSize="4xl" fontWeight="bold" color={mainColor}>
            {preco}
            <Text as="span" fontSize="md" color="#6C6C6C">
              {tipoFinal === 'mensal' ? '/mês' : '/anual'}
            </Text>
          </Text>

          <Box bg={'#FFFFFFB2'} p={4} borderRadius="12px" w="100%" border={isFamilia ? '1px solid #EB8B2A' : '1px solid #D8EAE9'}>
            <VStack align="start" spacing={3}>
              {beneficios.map((b, index) => (
                <HStack key={index}>
                  <Icon as={FaCheck} color={mainColor} />
                  <Text>{b}</Text>
                </HStack>
              ))}
            </VStack>
          </Box>

          <Button w="100%" bg={mainColor} color="white" borderRadius="full" onClick={onAssinar}>
            Quero este plano!
          </Button>
        </VStack>
      </Box>
    );
  }

  return planosExibir.length && !loadingAssinatura ? (
    !assinaturaLiberada ? (
      <>
        {header ? user.loggedIn ? <ChildHeader /> : <NoUserHeader /> : null}
        <Box p={8}>
          <Flex direction={'column'} bg={'#F3F3F3'} p={6} borderRadius={10}>
            <Image src={AvisoPendencias} w={30} alignSelf={'center'} />
            <Text fontSize={16} fontWeight={'bold'} color={'#585858'} my={4}>
              Não é <span style={{ color: '#CB0000' }}> possível reativar </span> seu contrato
            </Text>
            <Spacer border={'0.1px solid #E6E6E6'} />
            <Text fontSize={'16px'} color={'#585858'} my={4}>
              Você só poderá reativar seu contrato 90 dias após a data do cancelamento
            </Text>

            <Button
              isFullWidth
              colorScheme="teal"
              onClick={() => {
                navigate('/dashboard');
              }}
            >
              Entendi
            </Button>
          </Flex>
        </Box>
      </>
    ) : (
      <>
        <Modal isOpen={modalAnualOpen} onClose={() => setModalAnualOpen(false)} isCentered>
          <ModalOverlay />
          <ModalContent borderRadius={20} p={4} maxW="400px">
            <ModalCloseButton />

            {planoSelecionado &&
              (() => {
                const planoVoucher = Number(user?.voucher?.voucher?.plano_id);

                const isVoucher =
                  user?.voucher?.voucher?.voucher_type === 'Assinatura' &&
                  (!planoVoucher || planoVoucher === 0 || String(planoSelecionado.id) === String(planoVoucher));
                const parcelasBase = isVoucher ? planoSelecionado?.parcelasFiltradasVoucher || [] : planoSelecionado?.parcelas || [];

                const parcelaMensal = parcelasBase.find((p) => Number(p.quantidade) === 12);
                const parcelaAnual = parcelasBase.find((p) => Number(p.quantidade) === 1);
                let economiaPercent = null;
                const parcelaCheia = planoSelecionado.parcelas?.find((p) => Number(p.quantidade) === 1);

                if (parcelaMensal && parcelaAnual) {
                  const valorOriginal = Number(parcelaCheia.min_valor);
                  const valorComDesconto = Number(parcelaMensal.min_valor);

                  economiaPercent = Math.round(((valorOriginal - valorComDesconto) / valorOriginal) * 100);
                }

                return (
                  <>
                    <Text textAlign="center" color="#2A918A" fontSize="2em" fontWeight="bold" mb={2}>
                      Economize <br /> assinando anual!
                    </Text>

                    {economiaPercent !== null && (
                      <Text textAlign="center" fontSize="1em" mb={4} color="#616161">
                        Obtenha <b>{economiaPercent}%</b> de desconto assinando anual!
                      </Text>
                    )}

                    <PlanoCard
                      planId={planoSelecionado.id}
                      titulo={planoSelecionado.nome}
                      beneficios={planoSelecionado.beneficios?.map((b) => b.descricao || b)}
                      recomendado={true}
                      tipo={isVoucherMensal ? 'mensal' : 'anual'}
                      plan={planoSelecionado}
                      onAssinar={() => handleSubmit(planoSelecionado, { anual: true })}
                    />
                    <Center>
                      <Button
                        mt={3}
                        w="80%"
                        onClick={() => {
                          setModalAnualOpen(false);
                          handleSubmit(planoSelecionado, { anual: false });
                        }}
                        color="#424242"
                        bg="#EEEEEE"
                        borderRadius="1em"
                      >
                        Não quero economizar
                      </Button>
                    </Center>
                  </>
                );
              })()}
          </ModalContent>
        </Modal>
        {header !== false ? user.loggedIn ? <ChildHeader /> : <NoUserHeader /> : null}
        <DrawerIndicacao disclosure={{ isOpen: drawerOpen, onClose: () => setDrawerOpen(false) }} clientId={clientId} />

        <Box p={2} borderRadius={10} m={2} display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
          <Image src={FamiliaIcon} alt="Emoji de dinheiro" width={60} mb={2} />
          <Text color="#616161" textAlign="center">
            No DeoVita você tem acesso a Pronto Atendimento 24h, Pediatria Online 24h +12 especialidades.
          </Text>
          <Text color="#616161" textAlign="center">
            Além de um veterinário online para tirar dúvidas sobre a saúde do seu amigo de quatro patas.
          </Text>
        </Box>
        {/*
        <Box w="100%" display="flex" justifyContent="center" alignItems="center" mb={2}>
          <Text color={!isAnual ? '#237973' : '#616161'} fontWeight="bold" mr={2}>
            Mensal
          </Text>
          <Switch colorScheme="teal" isChecked={isAnual} onChange={() => setIsAnual((prev) => !prev)} size="lg" id="switch-anual" mx={2} />
          <Text color={isAnual ? '#237973' : '#616161'} fontWeight="bold" ml={2}>
            Anual
          </Text>
        </Box>
        */}

        <Flex w="100%" justify="center" align="center" py={2}>
          <Box
            w={{ base: '95%', md: '70%', lg: '50%' }}
            maxW="500px"
            mx="auto"
            border="1px solid #5AB2AE"
            p={2}
            borderRadius={10}
            boxShadow="md"
            bg="white"
          >
            {user && user.voucher && user.voucher.voucher && (
              <Box mb={4} display="flex" flexDirection="column" alignItems="center">
                <Text fontWeight="bold" color="#2A918A" fontSize="md" letterSpacing={1} mb={2}>
                  Voucher Aplicado
                </Text>

                <Flex align="center" bg="#F7FDFC" px={4} py={2} borderRadius={10} boxShadow="sm" gap={3}>
                  <Text fontSize="sm" color="#616161" fontWeight="medium">
                    {user.voucher.voucher.voucher_type === 'Assinatura'
                      ? user.voucher.voucher.voucher
                      : user.voucher.voucher.vendedor_id || user.voucher.voucher.voucher}
                  </Text>

                  <IconButton
                    aria-label="Remover voucher"
                    icon={<CloseIcon boxSize={3.5} />}
                    size="sm"
                    variant="ghost"
                    colorScheme="red"
                    borderRadius="full"
                    _hover={{
                      bg: 'red.50',
                      transform: 'scale(1.05)',
                    }}
                    _active={{
                      transform: 'scale(0.95)',
                    }}
                    onClick={() => {
                      setUser((prevUser) => ({
                        ...prevUser,
                        voucher: null,
                      }));
                    }}
                  />
                </Flex>
              </Box>
            )}
            {planosExibir.length > 0 && (
              <Tabs variant="unstyled" w="100%">
                <TabList
                  p={1}
                  borderRadius="10px"
                  display="flex"
                  mb={2}
                  overflowX="auto"
                  sx={{
                    '::-webkit-scrollbar': { height: '6px' },
                    '::-webkit-scrollbar-thumb': { background: '#E0E0E0', borderRadius: '10px' },
                  }}
                >
                  {planosExibir.map((plan, idx) => (
                    <Tab
                      key={plan.id}
                      _selected={{
                        bg: '#2A918A',
                        color: 'white',
                        borderRadius: '10px',
                      }}
                      px={6}
                      py={3}
                      fontWeight="medium"
                      color="#2A918A"
                      minW="180px"
                      flexShrink={0}
                      whiteSpace="nowrap"
                    >
                      <HStack spacing="6px">
                        {plan.id === 29 ? <Icon as={MdFamilyRestroom} /> : <Icon as={FaUser} />}
                        <Text>{plan.nome}</Text>
                      </HStack>
                    </Tab>
                  ))}
                </TabList>
                <TabPanels mt={4}>
                  {planosExibir.map((plan) => {
                    let valorFinal = null;
                    let descontoPercent = null;
                    const planosVoucher = normalizarArray(user?.voucher?.voucher?.plano_ids);

                    const isVoucher =
                      user?.voucher?.voucher?.voucher_type === 'Assinatura' &&
                      (!planosVoucher.length || planosVoucher.includes(0) || planosVoucher.includes(Number(plan.id)));
                    if (isVoucher) {
                      descontoPercent = user.voucher.voucher.percent;
                    }
                    const parcela = plan.parcelas?.find((p) => p.quantidade === 1);
                    if (parcela && descontoPercent) {
                      valorFinal = Number(parcela.min_valor) * (1 - descontoPercent / 100);
                    } else if (isVoucher) {
                      valorFinal = user.voucher.voucher.valor_final;
                    }
                    return (
                      <TabPanel key={plan.id}>
                        <PlanoCard
                          planId={plan.id}
                          titulo={plan.nome}
                          beneficios={plan.beneficios ? plan.beneficios.map((b) => b.descricao || b) : []}
                          recomendado={plan.recomendado}
                          tipo={isVoucherAnual ? 'anual' : isVoucherMensal ? 'mensal' : 'mensal'}
                          plan={plan}
                          onAssinar={() => {
                            setPlanoSelecionado(plan);
                            if (isVoucherAnual) {
                              handleSubmit(plan, { anual: true });
                            } else if (isVoucherMensal) {
                              handleSubmit(plan, { anual: false });
                            } else {
                              setModalAnualOpen(true);
                            }
                          }}
                        />
                      </TabPanel>
                    );
                  })}
                </TabPanels>
              </Tabs>
            )}
          </Box>
        </Flex>
        {/* Box de menor valor movida para PagamentoTelemedicina.jsx */}
      </>
    )
  ) : error ? (
    navigate('/alerts/erro/cadastro_plano')
  ) : null;
}

export default Plano;
